import cx from 'classnames';
import {
  useCallback,
  type FunctionComponent,
  type PropsWithChildren,
} from 'react';

import { boardSwitcherSharedState } from '@trello/board-switcher';
import { useSharedStateSelector } from '@trello/shared-state';

import * as styles from './BoardSwitcherTiles.module.less';

interface BoardSwitcherTilesProps {
  testId?: string;
  className?: string;
}

export const BoardSwitcherTiles: FunctionComponent<
  PropsWithChildren<BoardSwitcherTilesProps>
> = ({ children, testId, className }) => {
  const layout = useSharedStateSelector(
    boardSwitcherSharedState,
    useCallback((value) => value.layout, []),
  );

  return (
    <div
      className={cx({
        [styles.boardList]: layout === 'list',
        [styles.boardTiles]: layout === 'grid',
        [className as string]: !!className,
      })}
      data-testid={testId}
      role={layout}
    >
      {children}
    </div>
  );
};
